import { render, staticRenderFns } from "./Property.vue?vue&type=template&id=f6b40810&scoped=true&"
import script from "./Property.vue?vue&type=script&lang=js&"
export * from "./Property.vue?vue&type=script&lang=js&"
import style0 from "./Property.vue?vue&type=style&index=0&id=f6b40810&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b40810",
  null
  
)

export default component.exports